import {
  Text,
  View,
  StyleSheet,
  Image,
  Document,
  Page,
  Font,
} from "@react-pdf/renderer";
import React from "react";
import homeImg from "../../../Assets/Images/homeImg.png";
import LatoRegular from "../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf";
import LatoBold from "../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf";

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  page: {
    justifyContent: "space-between",
    height: "100%",
  },
  infoarea: {
    alignItems: "center",
  },
  coverImage: {
    width: 570,
    height: 300,
  },
  numberContainer: {
    marginTop: 70,
    alignItems: "center",
  },
  numberCircle: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: "#245775",
    justifyContent: "center",
    alignItems: "center",
  },
  numberText: {
    fontSize: 42,
    fontFamily: "Lato",
    fontWeight: "700",
    color: "#FFFFFF",
  },
  title: {
    fontSize: 24,
    fontFamily: "Lato",
    fontWeight: "700",
    color: "#00577D",
    marginTop: 80,
  },
  subtitle: {
    fontSize: 18,
    fontFamily: "Lato",
    fontWeight: "300",
    color: "#00577D",
    marginTop: 5,
  },
  footer: {
    width: 540,
    borderTop: "1px solid #00577D",
    paddingTop: 5,
    flexDirection: "row",
    justifyContent: "space-between",
    position: "absolute",
    bottom: 0,
    left: 10,
    right: 21,
  },
  footersection: {
    flexDirection: "column",
  },
  footerTextheading: {
    fontSize: 10,
    fontWeight: 700,
    fontFamily: "Lato",
    color: "#76A3BE",
  },
  footerText: {
    fontSize: 8,
    fontFamily: "Lato",
    fontWeight: 400,
    color: "#76A3BE",
  },
});

const HomeFirst = () => {
  return (
    <View style={styles.page}>
      {/* Image at the Top */}
      <View style={styles.infoarea}>
        <Image src={homeImg} style={styles.coverImage} />
        <View style={styles.numberContainer}>
          <View style={styles.numberCircle}>
            <Text style={styles.numberText}>1</Text>
          </View>
          <Text style={styles.title}>Home</Text>
          <Text style={styles.subtitle}>YOUR STARTER QUADRANT</Text>
        </View>
      </View>

      {/* Footer Section */}
      <View style={styles.footer}>
        <View style={styles.footersection}>
          <Text style={styles.footerTextheading}>SELF REPORT</Text>
          <Text style={styles.footerText}>
            © Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by
            Transformational Performance & Transformed Leader. All rights
            reserved.
          </Text>
        </View>
        <Text style={styles.footerTextheading}>PAGE</Text>
      </View>
    </View>
  );
};

export default HomeFirst;
